import { environment } from '../../../environments/environment';

export const isFeatureEnabled = (key: string): boolean =>
  environment.features[key] ?? true;
